import { render, staticRenderFns } from "./Template-2.vue?vue&type=template&id=ad431646&scoped=true"
import script from "./Template-2.vue?vue&type=script&lang=js"
export * from "./Template-2.vue?vue&type=script&lang=js"
import style0 from "./Template-2.vue?vue&type=style&index=0&id=ad431646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad431646",
  null
  
)

export default component.exports